export default {"src":"/_next/static/media/register_corner_image.18356232.svg","height":270,"width":244};